import React from 'react';
import { useLang } from '../context/LanguageContext';
import { ArrowUpRight } from 'lucide-react';

const Services = () => {
  const { t } = useLang();
  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="section-pad bg-white border-y border-[#E8E2D5]">
      <div className="container-tight">
        <div className="text-center max-w-3xl mx-auto mb-20">
          <span className="eyebrow">{t.services.eyebrow}</span>
          <h2 className="h-display mt-6" style={{ fontSize: 'clamp(40px, 5vw, 64px)' }}>
            {t.services.title}
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-px bg-[#E8E2D5] border border-[#E8E2D5]">
          {/* Piercing card (priority) */}
          <button
            onClick={() => scrollTo('piercing')}
            className="group bg-white text-left p-10 md:p-14 relative overflow-hidden hover:bg-[#FAF8F4] transition-colors duration-500"
          >
            <div className="flex items-start justify-between mb-10">
              <span className="text-[10px] tracking-[0.3em] uppercase text-[#957340] border border-[#957340] px-3 py-1">
                {t.services.piercingTag}
              </span>
              <ArrowUpRight size={22} className="text-[#1A1A1A] group-hover:text-[#957340] group-hover:rotate-45 transition-all duration-500" />
            </div>
            <div className="aspect-[4/3] mb-8 image-hover">
              <img
                src="https://images.unsplash.com/photo-1692220527262-094906b793e5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MjJ8MHwxfHNlYXJjaHwyfHxsdXh1cnklMjBwaWVyY2luZ3xlbnwwfHx8fDE3ODIyMzY5MjZ8MA&ixlib=rb-4.1.0&q=85"
                alt="Piercing"
                className="w-full h-full object-cover"
              />
            </div>
            <div className="display text-[12px] tracking-[0.4em] uppercase text-[#8A8275] mb-3">01 —</div>
            <h3 className="h-display" style={{ fontSize: 'clamp(36px, 4vw, 52px)' }}>{t.services.piercingTitle}</h3>
            <p className="text-[15px] text-[#3A3A3A] leading-[1.8] mt-5 max-w-md">{t.services.piercingDesc}</p>
            <span className="link-underline mt-8 inline-block">{t.services.learnMore}</span>
          </button>

          {/* Tattoo card */}
          <button
            onClick={() => scrollTo('tattoo')}
            className="group bg-white text-left p-10 md:p-14 relative overflow-hidden hover:bg-[#FAF8F4] transition-colors duration-500"
          >
            <div className="flex items-start justify-between mb-10">
              <span className="text-[10px] tracking-[0.3em] uppercase text-[#8A8275]">—</span>
              <ArrowUpRight size={22} className="text-[#1A1A1A] group-hover:text-[#957340] group-hover:rotate-45 transition-all duration-500" />
            </div>
            <div className="aspect-[4/3] mb-8 image-hover">
              <img
                src="https://images.pexels.com/photos/4662164/pexels-photo-4662164.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
                alt="Tattoo"
                className="w-full h-full object-cover"
              />
            </div>
            <div className="display text-[12px] tracking-[0.4em] uppercase text-[#8A8275] mb-3">02 —</div>
            <h3 className="h-display" style={{ fontSize: 'clamp(36px, 4vw, 52px)' }}>{t.services.tattooTitle}</h3>
            <p className="text-[15px] text-[#3A3A3A] leading-[1.8] mt-5 max-w-md">{t.services.tattooDesc}</p>
            <span className="link-underline mt-8 inline-block">{t.services.learnMore}</span>
          </button>
        </div>
      </div>
    </section>
  );
};

export default Services;
